module.exports = __webpack_public_path__ + "4e54f9ec8046c5789723238ce86a6013.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/medialunas.png
// module id = 609
// module chunks = 0